import "./MosaicView.css";

function formatTime(s) {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
}

export default function MosaicView({ exhibicion, selectedId, onSelectSeccion }) {
  const secciones = exhibicion?.secciones || [];

  return (
    <div className="exhi-mosaic">
      {secciones.map((s) => {
        const thumbUrl = s.medioVisual?.thumbUrl || null;
        const isVideo = s.medioVisual?.mediaType === "VIDEO";
        return (
          <div
            key={s.idSeccion}
            className={`exhi-mosaic-card${selectedId === s.idSeccion ? " exhi-mosaic-card--selected" : ""}`}
            onClick={() => onSelectSeccion && onSelectSeccion(s)}
          >
            <div className="exhi-mosaic-thumb-wrap">
              {thumbUrl ? (
                <img src={thumbUrl} alt={s.titulo} className="exhi-mosaic-thumb" />
              ) : (
                <span className="exhi-mosaic-no-thumb">
                  {isVideo ? "🎬" : "🖼️"}
                </span>
              )}
            </div>
            <div className="exhi-mosaic-info">
              <div className="exhi-mosaic-info-title">{s.titulo}</div>
              <div className="exhi-mosaic-info-meta">
                {formatTime(s.tiempoInicio)} · {s.duracion}s
                {s.mediosAudio?.length > 0 && ` · 🎵 ×${s.mediosAudio.length}`}
              </div>
            </div>
          </div>
        );
      })}
      {secciones.length === 0 && (
        <div className="text-muted py-4">Sin secciones.</div>
      )}
    </div>
  );
}
